module.exports = __webpack_public_path__ + "img/logo-sm.3bccd69b.png";